import { Counter, Flex, Radio, Text } from "@theorgchartdev/storybook";
import { useState, useImperativeHandle } from "react";
import { GetWSMgr, ReRenderCanvas } from "@/Utils/StateLib";
import { enumScalingMethod } from "@coreapp/constants";
import { appstr } from "@coreapp/utils/appstr";

export const ScalingOptions = [
  ["maintainaspect", enumScalingMethod.lockaspect],
  ["freeaspect", enumScalingMethod.unlockaspect],
  ["scalehorz", enumScalingMethod.scalehorz],
  ["scalevert", enumScalingMethod.scalevert],
  ["scalefill", enumScalingMethod.scaletopage]
];

export const PhotoScaleContent = ({ handleRef, onClose, srcElement }) => {
  const wsMgr = GetWSMgr();
  const target = srcElement ?? wsMgr?.GetFirstSelectedBox(true);
  const defaultScaleH = target?.GetSPictureScaleH() ?? 100;
  const defaultScaleW = target?.GetSPictureScaleW() ?? 100;
  const defaultScaleMethod = target?.GetScalingMethod() ?? 0;

  const [scaleMethod, setScaleMethod] = useState(defaultScaleMethod);
  const [widthScale, setWidthScale] = useState(defaultScaleW);
  const [heightScale, setHeightScale] = useState(defaultScaleH);

  const onSave = () => {
    let newScaleH = heightScale;
    if (newScaleH < 10) newScaleH = 10;

    let newScaleW = widthScale;
    if (newScaleW < 10) newScaleW = 10;

    if (scaleMethod == enumScalingMethod.lockaspect) newScaleW = newScaleH;

    if (
      newScaleH != defaultScaleH ||
      newScaleW != defaultScaleW ||
      scaleMethod != defaultScaleMethod
    ) {
      wsMgr.StartCheckPoint();
      target.SetSPictureScale(newScaleW, newScaleH, scaleMethod, true);
      wsMgr.EndCheckPoint();
      wsMgr.RecalcChartLayout(target);
      ReRenderCanvas();
    }
    onClose();
  };

  useImperativeHandle(handleRef, () => ({ onSave }));

  const handleScaleMethodChange = value => {
    setScaleMethod(value);
    if (value === enumScalingMethod.scalehorz) {
      setWidthScale(100);
    }
    if (value === enumScalingMethod.scalevert) {
      setHeightScale(100);
    }
  };

  const handleInputWidthScale = newValue => {
    setWidthScale(newValue);
  };

  const handleInputHeightScale = newValue => {
    setHeightScale(newValue);
  };

  const BuildRadioScaleOptions = () => {
    return (
      <Flex direction={"column"} gap={"8px"}>
        {ScalingOptions.map(([label, value]) => (
          <Radio
            key={`scale-option-${value}`}
            id={`scale-option-${value}`}
            label={`${appstr(label)}`}
            value={value}
            checked={value === scaleMethod}
            onChange={() => handleScaleMethodChange(value)}
          />
        ))}
      </Flex>
    );
  };

  const scaleHDisabled =
    scaleMethod === enumScalingMethod.scalevert || scaleMethod === enumScalingMethod.scaletopage;

  const scaleWDisabled =
    scaleMethod === enumScalingMethod.lockaspect ||
    scaleMethod === enumScalingMethod.scalehorz ||
    scaleMethod === enumScalingMethod.scaletopage;

  return (
    <Flex direction={"column"} gap={"12px"}>
      {BuildRadioScaleOptions()}
      <Flex gap={"20px"} justifyContent={"space-between"}>
        <Text size={"small"} modifier={"medium"}>
          {appstr("scaleh")}
        </Text>
        <Counter
          key={0}
          inputId={"scale-height-counter"}
          callbackOnInputChange
          onChange={handleInputHeightScale}
          currentValue={heightScale}
          defaultValue={defaultScaleH}
          inputProps={{
            disabled: scaleHDisabled
          }}
          disabled={scaleHDisabled}
          minValue={10}
          maxValue={100}
          incrementValue={5}
          size={"small"}
        />
      </Flex>
      <Flex gap={"20px"} justifyContent={"space-between"}>
        <Text size={"small"} modifier={"medium"}>
          {appstr("scalew")}
        </Text>
        <Counter
          key={1}
          inputId={"scale-width-counter"}
          callbackOnInputChange
          onChange={handleInputWidthScale}
          currentValue={widthScale}
          defaultValue={defaultScaleW}
          inputProps={{
            disabled: scaleWDisabled
          }}
          disabled={scaleWDisabled}
          minValue={10}
          incrementValue={5}
          maxValue={100}
          size={"small"}
        />
      </Flex>
    </Flex>
  );
};
